<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet
        :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
        class="pa-3"
      >
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-card elevation="6" class="pa-2">
        <div v-if="loading_logs === true">
          <v-sheet
            :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
            class="pa-3"
          >
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
          </v-sheet>
        </div>
        <div v-else>
          <v-form ref="search" @submit.prevent="getInvoiceDetailByProductCode">
            <div class="grid_full">
              <div class="grid_flex">
                <v-col cols="12" sm="6" md="3" lg="3" xl="3" class="pb-0">
                  <v-autocomplete
                    v-model="selected_store_id"
                    :items="store_list"
                    item-value="id"
                    item-text="store_name"
                    label="เลือกสาขา"
                    hide-details="auto"
                    clearable
                    outlined
                    class="mr-1 ml-1"
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12" sm="6" md="3" lg="3" xl="3" class="pb-0">
                  <v-menu
                    ref="menu_date_start"
                    v-model="menu_date_start"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        color="#86bc3a"
                        clearable
                        class="input_width"
                        v-model="date_start"
                        label="วันเริ่มต้น"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      locale="TH"
                      color="#86bc3a"
                      v-model="date_start"
                      no-title
                      scrollable
                      @input="
                        (val) => {
                          date_start = val;
                          menu_date_start = false;
                        }
                      "
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" sm="6" md="3" lg="3" xl="3" class="pb-0">
                  <v-menu
                    ref="menu_date_end"
                    v-model="menu_date_end"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        color="#86bc3a"
                        clearable
                        class="input_width"
                        v-model="date_end"
                        label="วันสิ้นสุด"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      locale="TH"
                      color="#86bc3a"
                      v-model="date_end"
                      no-title
                      scrollable
                      @input="
                        (val) => {
                          date_end = val;
                          menu_date_end = false;
                        }
                      "
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </div>

              <div class="pa-4 pt-0 grid_flex">
                <v-autocomplete
                  v-model="selected_product_id"
                  :items="logs_list"
                  clearable
                  color="#86bc3a"
                  class="mr-1 ml-1"
                  item-text="search_logs"
                  item-value="id"
                  type="text"
                  label="รายการสินค้า"
                  :rules="[(v) => !!v || 'กรุณาเลือกรายการสินค้า']"
                  hide-details="auto"
                  outlined
                ></v-autocomplete>
                <v-btn
                  x-large
                  type="submit"
                  class="grad-success-bg white--text btn_mobile"
                  style="font-size: 18px"
                  >ค้นหา</v-btn
                >
              </div>
            </div>
          </v-form>
        </div>

        <div>
          <!-- header -->
          <div class="ma-4 border_card">
            <div class="grid_half pa-4">
              <div class="d-flex">
                <div class="mr-3">รหัสสินค้า :</div>
                <div>{{ selected_product.product_code ? selected_product.product_code : '-' }}</div>
              </div>
              <div class="grid_flex">
                <div class="mr-3">ชื่อสินค้า :</div>
                <div>{{ selected_product.name ? selected_product.name : '-' }}</div>
              </div>
              <div class="d-flex">
                <div class="mr-3">วันเริ่มต้น</div>
                <div>{{ date_start ? date_start : '-' }}</div>
              </div>
              <div class="grid_flex">
                <div class="mr-3">วันสิ้นสุด</div>
                <div>{{ date_end ? date_end : '-' }}</div>
              </div>
            </div>
          </div>

          <div class="ma-4 border_card">
            <v-card-title> ประวัติการดำเนินการ </v-card-title>
            <v-data-table
              :headers="header_logs"
              :items="detail"
              :items-per-page="perPage"
              :footer-props="footer_Props"
              mobile-breakpoint="0"
            >
              <template slot="item" slot-scope=""></template>
            </v-data-table>
          </div>
        </div>

        <v-overlay :value="overlay" class="z_index">
          <div class="text-center">
            <v-progress-circular
              indeterminate
              size="70"
              width="7"
              color="#86bc3a"
            ></v-progress-circular>
            <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
          </div>
        </v-overlay>
      </v-card>
    </div>
  </div>
</template>

<script>
import { HTTP } from "@/axios";
// import Swal from "sweetalert2";
import { diffChangeFormat } from "@/js/handler";

export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  data() {
    return {
      loading_page: false,
      date: "",
      extend_page: false,
      overlay: false,
      store_list: [],
      selected_store_id: null,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        "items-per-page-text": "รายการต่อหน้า",
      },
      perPage: -1,
      header_logs: [
        { text: "วันที่", value: "created_at" },
        { text: "รหัสบิล", value: "invoice_code" },
        { text: "เลขที่เอกสาร", value: "store_posid" }, // 👈 เพิ่มตรงนี้
        { text: "จำนวนลด", value: "qty" },
        { text: "หน่วย", value: "unit_name" }, // เพิ่มตรงนี้
        { text: "ราคาต่อหน่วย", value: "price" },
        { text: "รวม", value: "total" },
       
      ],
      header_date: [
        {
          text: "รายการ",
          value: "",
          sortable: false,
          fixed: true,
          width: "500px",
        },
        {
          text: "จำนวน",
          value: "",
          sortable: false,
          fixed: true,
          width: "250px",
        },
        {
          text: "หน่วยนับ",
          value: "",
          sortable: false,
          fixed: true,
          width: "250px",
        },
      ],
      header_history: [
        {
          text: "วันที่",
          value: "create_at",
          fixed: true,
          width: "140px",
        },
        {
          text: "รายการ",
          value: "detail",
          fixed: true,
          width: "300px",
        },
        {
          text: "จำนวน",
          value: "quantity",
          fixed: true,
          width: "180px",
        },
        {
          text: "หมายเหตุ",
          value: "note",
          fixed: true,
          width: "250px",
        },
        {
          text: "ผู้ดำเนินการ",
          value: "user_name",
          fixed: true,
          width: "150px",
        },
      ],
      data_history: [
        {
          id: 1,
          date: "24/02/2565",
          list_name: "ขาย คำสั่งซื้อ 12389745",
          quantity: 35,
          note: "ขวดแตก",
          username: "Admin",
        },
      ],
      detail: [],
      log_detail: [],
      data_list: [],
      logs_list: [],
      selected_product_id: null,
      date_start: "", // -> วันที่เริ่มต้น
      date_end: "", // -> วันที่สิ้นสุด
      menu_date_start: false,
      menu_date_end: false,
      selected_product: {}, // -> เก็บข้อมูลสินค้า (เช่น code / name)
    };
  },
  methods: {
    diffChange: function (value) {
      return diffChangeFormat(value);
    },
    diffTH(value) {
      const diff = value.split("/");
      const day = diff[0];
      const month = diff[1];
      const year = parseInt(diff[2]) + 543;
      return day + "/" + month + "/" + year;
    },
    getProducts() {
      // this.loading_logs = true;
      HTTP.post("/products/product/alllogs")
        .then((res) => {
          if (res.data.successful === true) {
            this.logs_list = res.data.object;
            this.loading_logs = false;
          }
        })
        .finally(() => {
          this.loading_logs = false;
        });
    },
    getStores() {
      HTTP.get("/customers/storelist").then((res) => {
        if (res.data.success === true) {
          const storeData = res.data.object;

          // เพิ่มตัวเลือก “ทั้งหมด” ไว้ที่รายการแรก
          this.store_list = [
            { id: "all", store_name: "ทั้งหมดทุกสาขา" },
            ...storeData,
          ];
        }
      });
    },
    getInvoiceDetailByProductCode() {
      if (!this.selected_product_id) return;

      this.overlay = true;

      // สมมุติ product_code เก็บใน logs_list จาก autocomplete
      const selectedProduct = this.logs_list.find(
        (p) => p.id === this.selected_product_id
      );
      if (!selectedProduct) return;

      // บันทึกชื่อสินค้า / รหัส
      this.selected_product = {
        product_code: selectedProduct.product_code,
        name: selectedProduct.name,
      };

      HTTP.post("/products/product/by-product", {
        product_code: selectedProduct.product_code,
        store_id: this.selected_store_id, // อาจต้องเช็คด้วยว่าเป็น all หรือไม่
        date_start: this.date_start,
        date_end: this.date_end,
      })
        .then((res) => {
          if (res.data.successful) {
            this.detail = res.data.object.map((item) => {
              return {
                ...item,
                created_at: this.formatDate(item.created_at),
              };
            });
          }
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    formatDate(date) {
      const d = new Date(date);
      const options = { year: "numeric", month: "2-digit", day: "2-digit" };
      return d.toLocaleDateString("th-TH", options); // แสดงแบบไทยเช่น 24/03/2568
    },
  },
  mounted() {
    this.getProducts();
    this.getStores();
  },
};
</script>

<style scoped>
.border_card {
  border: #b3b3b3 solid 1px;
}
.grid_full {
  display: grid;
  grid-template-columns: 100%;
}
.grid_flex {
  display: flex;
}
.grid_half {
  display: grid;
  grid-template-columns: 30% 70%;
  grid-gap: 15px 0;
}
.btn_mobile {
  width: 20%;
}
@media only screen and (max-width: 1024px) {
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
}
@media only screen and (max-width: 500px) {
  .grid_flex {
    display: block;
  }
  .btn_mobile {
    width: 100%;
    margin-top: 15px;
  }
}
</style>
